<template>
  <div class="share-box share-box-notebook pop">
    <div class="pop-box">
      <div class="pop-main">
        <div class="share-body">
          <div class="pop-title">
            <i class="icon-share"></i>
            <span class="share-title">{{$t('operation.share')}}</span>
          </div>
          <div class="share-options">
            <span class="option-tips">{{$t('operation.shareTimeLimit')}}</span>
            <div class="option-items">
              <div class="option-item" :class="{'active': expireType == 0}" @click="expireTypeSelect(0)">3 {{$t('operation.hours')}}</div>
              <div class="option-item" :class="{'active': expireType == 1}" @click="expireTypeSelect(1)">24 {{$t('operation.hours')}}</div>
              <div class="option-item" :class="{'active': expireType == 2}" @click="expireTypeSelect(2)">30 {{$t('operation.days')}}</div>
              <div class="option-item option-create" @click="generateLink">{{$t('operation.createLink')}}</div>
            </div>
            <div class="share-result">
              <div class="result result-link">
                <span class="option-tips">{{$t('operation.shareLink')}}</span>
                <input type="text" name="shareLink" class="disable" v-model="shareResult.link">
              </div>
              <div class="result result-pwd">
                <span class="option-tips">{{$t('operation.password')}}</span>
                <input type="text" name="sharePwd" class="disable" v-model="shareResult.pwd">
              </div>
              <div class="result result-copy">
                <span class="option-tips"></span>
                <button class="option-item copy-link" :class="{'active': shareResult.link != ''}" @click="doCopy">{{$t('operation.copy')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <i class="icon-close" @click="toCloseShareBox"></i>
    </div>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
export default {
  name: 'shareBox',
  props: ['images', 'shareType'],
  data () {
    return {
      expireType: 0, // 过期时间0:3小时，1:24小时，2:30天
      shareLinks: [
        {link: '', pwd: ''},
        {link: '', pwd: ''},
        {link: '', pwd: ''}
      ]
    }
  },
  created () {
    this.expireType = 0
  },
  computed: {
    shareResult () {
      return this.shareLinks[this.expireType]
    },
    expireTime () {
      var expire = 0
      if (this.expireType === 0) {
        expire = 3 * 60 * 60 * 1000
      } else if (this.expireType === 1) {
        expire = 24 * 60 * 60 * 1000 // 24h
      } else if (this.expireType === 2) {
        expire = 30 * 24 * 60 * 60 * 1000 // 30days
      }
      var expireDate = new Date(new Date().getTime() + expire)
      return expireDate.toLocaleString()
    }
  },
  methods: {
    generateLink: function () {
      var shareImages = []
      for (var i = 0; i < this.images.length; i++) {
        if (this.shareType === 0 || this.shareType === 1) {
          shareImages.push(this.images[i].id)
        } else if (this.shareType === 2) {
          shareImages.push(this.images[i].name)
        }
      }
      shareImages = shareImages.join(',')
      HttpClient.postData(Config.APP_HOST + '/v1/book/share/link', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        fileStrs: shareImages,
        type: this.shareType,
        expireType: this.expireType
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.shareLinks[this.expireType].link = response.body.link
          this.shareLinks[this.expireType].pwd = response.body.code
        }
      })
    },
    doCopy: function () {
      if (this.shareResult.link === '') return
      var copyText = this.$t('share.shareNotebookLink') + this.shareResult.link + ' ' + this.$t('operation.password') + ': ' + this.shareResult.pwd + this.$t('share.expire') + this.expireTime
      var thisObj = this
      this.$copyText(copyText).then(function (e) {
        thisObj.$toasted.show(thisObj.$t('player.copyToClipboard'), {
          duration: 2000,
          position: 'bottom-center',
          containerClass: 'share-body',
          singleton: true
        })
      }, function (e) {
        // console.log(e)
      })
    },
    // 之前的
    expireTypeSelect: function (type) {
      this.expireType = type
    },
    toCloseShareBox: function () {
      this.$emit('toCloseShareBox')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.share-box-notebook
  &.pop
    .pop-box
      width 500px
      height 290px
      line-height initial
      .share-body
        position relative
        display block
        width 100%
        height 100%
        padding 18px 24px
        box-sizing border-box
        .pop-title
          display block
          text-align left
          height 24px
          font-size 20px
          line-height 24px
        .share-options
          padding 40px 0px
          text-align left
          .option-tips
            display inline-block
            font-weight bold
            padding 4px 0px
            font-size 14px
            height 19px
            line-height 19px
          .option-items
            position relative
            display block
            padding 8px 0px 18px
            margin-bottom 8px
            font-size 12px
            overflow hidden
            border-bottom 1px solid #cacaca
          .option-item
            float left
            display block
            margin-right 35px
            min-width 70px
            height 28px
            line-height 28px
            padding 0
            text-align center
            border 1px solid #cacaca
            border-radius 4px
            box-sizing border-box
            cursor pointer
            &.active, &.option-create
              background-color rgba(61,61,61,1)
              color #ffffff
            &.option-create
              float right
              margin-right 0px
          .share-result
            display flex
            flex-direction row
            justify-content space-between
            width 100%
            height 66px
            .option-tips
              display block
            .result
              display flex
              flex-direction column
              justify-content space-between
              &.result-link
                width 208px
              &.result-pwd
                width 60px
              &.result-copy
                width 80px
              input
                padding 8px 4px
                font-size 12px
                background-color #f5f5f5
                border-radius 4px
                outline none
              .copy-link
                width 80px
                color #ffffff
                background-color #d8d8d8
                border-color #d8d8d8
                &.active
                  background-color rgba(61,61,61,1)
.toasted-container
  &.share-body
    bottom 45% !important
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ShareBox.vue